import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddEquipageModal",
  tabindex: "-1",
  ref: "addEquipageModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 mb-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "col-12 mb-1"
}
const _hoisted_11 = { class: "card shadow-sm border-0" }
const _hoisted_12 = { class: "card-body d-flex flex-column align-items-center justify-content-center p-4" }
const _hoisted_13 = {
  for: "xlsx-upload",
  class: "d-flex flex-column align-items-center justify-content-center w-100",
  style: {"cursor":"pointer"}
}
const _hoisted_14 = {
  key: 0,
  class: "mt-3 text-success fw-semibold"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table table-bordered table-striped" }
const _hoisted_18 = {
  key: 2,
  class: "col-md-12 mt-3"
}
const _hoisted_19 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "equipageForm",
            onSubmit: _ctx.addEquipage,
            "validation-schema": _ctx.equipageSchema,
            enctype: "multipart/form-data"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "alert alert-info mb-2" }, [
                    _createElementVNode("strong", null, "Procédure :"),
                    _createElementVNode("br"),
                    _createTextVNode(" 1. Téléchargez le modèle XLSX en cliquant sur le bouton ci-dessous."),
                    _createElementVNode("br"),
                    _createTextVNode(" 2. Remplissez le fichier avec les informations demandées pour chaque membre d'équipage."),
                    _createElementVNode("br"),
                    _createTextVNode(" 3. Enregistrez le fichier sur votre ordinateur."),
                    _createElementVNode("br"),
                    _createTextVNode(" 4. Importez ou transmettez le fichier via l'interface prévue (ou contactez l'administrateur si besoin). ")
                  ], -1)),
                  (!_ctx.isShow)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.xlsxTemplateUrl,
                        download: "",
                        class: "btn btn-outline-primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShow = true))
                      }, " Télécharger le modèle XLSX à remplir ", 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", {
                              class: "mb-2",
                              style: {"font-size":"2rem","color":"#0d6efd"}
                            }, [
                              _createElementVNode("i", { class: "fas fa-file-excel" })
                            ], -1)),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fw-bold mb-1" }, "Importer le fichier XLSX rempli", -1)),
                            _cache[6] || (_cache[6] = _createElementVNode("span", {
                              class: "text-muted mb-2",
                              style: {"font-size":"0.95rem"}
                            }, "Sélectionnez le fichier que vous avez complété pour ajouter plusieurs membres d'équipage en une seule fois.", -1)),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "btn btn-primary px-4 py-2 mt-2" }, "Choisir un fichier", -1)),
                            _createElementVNode("input", {
                              name: "fichier",
                              id: "xlsx-upload",
                              type: "file",
                              accept: ".xlsx",
                              style: {"display":"none"},
                              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                            }, null, 32),
                            (_ctx.selectedFileName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Fichier sélectionné : " + _toDisplayString(_ctx.selectedFileName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tableRows.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("table", _hoisted_17, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (header, idx) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  key: 'header-' + idx
                                }, _toDisplayString(header), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableRows, (row, rIdx) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: 'row-' + rIdx
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cIdx) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: 'cell-' + rIdx + '-' + cIdx
                                  }, _toDisplayString(cell), 1))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[9] || (_cache[9] = _createElementVNode("button", {
                          class: "default-btn me-20 transition border-0 fw-medium text-white p-8 rounded-1 fs-md-15 fs-lg-16 bg-success",
                          type: "submit"
                        }, " Enregistrer l'équipage ", -1)),
                        _createVNode(_component_router_link, {
                          to: "/liste-manifestes",
                          class: "btn btn-danger transition border-0 lh-1 fw-medium p-10 pe-15"
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                            _createElementVNode("span", { class: "position-relative" }, null, -1),
                            _createTextVNode("Annuler ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetValue()))
        })
      ])
    ])
  ], 512))
}